// base
export const GET_LIST = "GET_LIST";
export const GET_ONE = "GET_ONE";
export const CREATE = "CREATE";
export const BULK_CREATE = "BULK_CREATE";
export const UPDATE = "UPDATE";
export const BULK_UPDATE = "BULK_UPDATE";
export const BULK_DELETE = "BULK_DELETE";
export const COUNT = "COUNT";
export const COUNTAMOUNT = "COUNTAMOUNT";

// method
export const GET = "GET";
export const POST = "POST";
export const DELETE = "DELETE";
export const PATCH = "PATCH";
export const PUT = "PUT";

// auth
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const VERIFY_SMS = "VERIFY_SMS";
export const SEND_SMS = "SEND_SMS";
export const ME = "ME";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";

// base
export const VARIABLE = "VARIABLE";
export const GET_PRICE = "GET_PRICE";

// csv
export const EXPORT = "EXPORT";
export const IMPORT = "IMPORT";

// request
export const RESPONSE_TYPE = {
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
  ERROR: "ERROR"
};
